export default {"src":"/_next/static/media/language-icon.9eaec2ba.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};